import * as THREE from 'three';
import * as CANNON from 'cannon-es';

export class MachineGunBullet {
  public mesh: THREE.Mesh;
  public body: CANNON.Body;
  public isActive: boolean = true;
  public owner: 'player' | 'enemy';
  public damage: number;

  private lifetime: number = 3; // Shorter lifetime than cannon
  private age: number = 0;

  constructor(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    owner: 'player' | 'enemy',
    damage: number
  ) {
    this.owner = owner;
    this.damage = damage;

    // 创建子弹网格 (smaller than cannon bullet)
    const geometry = new THREE.SphereGeometry(0.08);
    const material = new THREE.MeshStandardMaterial({
      color: owner === 'player' ? 0xffff00 : 0xff4400,
      emissive: owner === 'player' ? 0xffff00 : 0xff4400,
      emissiveIntensity: 0.5
    });
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.position.copy(position);
    this.mesh.castShadow = true;

    // 创建物理体
    const shape = new CANNON.Sphere(0.08);
    this.body = new CANNON.Body({
      mass: 0.05,
      shape: shape,
      position: new CANNON.Vec3(position.x, position.y, position.z),
      linearDamping: 0.1
    });

    // 设置速度
    const velocity = direction.clone().multiplyScalar(40);
    this.body.velocity.set(velocity.x, velocity.y, velocity.z);

    // 添加用户数据
    this.body.userData = {
      type: 'machinegun_bullet',
      bullet: this,
      owner: owner
    };
  }

  update(deltaTime: number): void {
    if (!this.isActive) return;

    this.age += deltaTime;

    // 超时销毁
    if (this.age >= this.lifetime) {
      this.destroy();
      return;
    }

    // 同步位置
    this.mesh.position.copy(this.body.position as any);
    this.mesh.quaternion.copy(this.body.quaternion as any);
  }

  destroy(): void {
    this.isActive = false;
  }
}
